import format from 'date-fns/format';
import { dateISO } from 'jsonous';
import { Maybe, just } from 'maybeasy';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { DateField } from '../../Types';

export interface Props {
  field: DateField;
  disabled: boolean;
}

export const parseDate = (dateString: string): Date =>
  dateISO.decodeAny(dateString).getOrElseValue(new Date());

const dateToLocalDate = (date: Date) => format(date, 'yyyy-MM-dd');

const getNewDate = (value: Maybe<Date>, e: React.ChangeEvent<HTMLInputElement>): Date => {
  const now = new Date();
  return value
    .map(
      (value) =>
        new Date(
          parseDate(e.target.value).getFullYear(),
          parseDate(e.target.value).getMonth(),
          parseDate(e.target.value).getDate(),
          value.getHours(),
          value.getMinutes(),
        ),
    )
    .getOrElse(
      () =>
        new Date(
          parseDate(e.target.value).getFullYear(),
          parseDate(e.target.value).getMonth(),
          parseDate(e.target.value).getDate(),
          now.getHours(),
          now.getMinutes(),
        ),
    );
};

const onChange = (field: DateField) =>
  action(
    (e: React.ChangeEvent<HTMLInputElement>) => (field.value = just(getNewDate(field.value, e))),
  );

const DateInput: React.FC<Props> = ({ field, disabled }) => (
  <div className="flex flex-col mr-2">
    <label htmlFor="send-date" className="font-semibold text-sm">
      <T kind="Date" />
    </label>
    <input
      type="date"
      id="send-date"
      value={dateToLocalDate(field.value.getOrElseValue(new Date()))}
      onChange={onChange(field)}
      name="send-date"
      className="rounded border-gray-300 w-36 disabled:bg-gray-50 disabled:text-gray-400"
      min={dateToLocalDate(new Date())}
      disabled={disabled}
    />
  </div>
);

export default observer(DateInput);
